import ScrollMagic from 'scrollmagic';
import 'debug.addIndicators';
import { TweenLite, Power3 } from 'gsap';

const scrollToTarget = (e) => {
  const clickedElement = e.currentTarget;
  const id = clickedElement.getAttribute('js-scroll-to');

  const header = document.querySelector('header');
  const headerHeight = header.offsetHeight;
  const target = `[id='${id}']`;
  TweenLite.to(window, 0.8, {
    scrollTo: {
      y: target,
      offsetY: headerHeight * 2,
      autoKill: false
    },
    ease: Power3.easeInOut
  });
}

const toggleFooter = () => {
  const controller = new ScrollMagic.Controller();
  const el = document.querySelector('[js-main-location]');
  if (el) {
    new ScrollMagic.Scene({
      triggerElement: el
    })
      // .addIndicators()
      .setClassToggle('[js-location-footer]', 'show')
      .addTo(controller);
  }
};

function eventHandler() {
  const footerNavItems = document.querySelectorAll('[js-scroll-to]');
  if (footerNavItems) {
    Array.prototype.forEach.call(footerNavItems, el => {
      el.addEventListener('click', scrollToTarget, false);
    });
  }
}

const locationFooter = async () => {
  toggleFooter();
  eventHandler();
};

export default locationFooter;
